<template>
  <div class="card">
    <p>
      <router-link
        :to="{ name: 'profile', params: { id: advert.user.id } }"
        class="body-color"
      >
        <avatar :user="advert.user" />
        {{ advert.user.first_name }} {{ advert.user.last_name }}
      </router-link>

      <span class="text-muted">sponsored post</span>
    </p>

    <span class="price">
      {{ formatPrice(advert.price) }}
    </span>

    <span class="title">
      {{ advert.title }}
    </span>

    <div class="description small">
      {{ advert.description }}
    </div>

    <div
      v-if="advert.image_url"
      class="image stretched"
    >
      <img
        :src="advert.image_url"
        alt
        class="img-fluid"
      >
    </div>

    <div class="learn-more">
      <button
        type="button"
        class="btn btn-primary btn-sm"
        @click="advertClicked"
      >
        Learn More
      </button>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

export default {
  components: {
    Avatar,
  },
  props: {
    advert: {
      type: Object,
      required: true,
    },
  },
  methods: {
    advertClicked() {
      alert('TODO: Record the ad click and then go to the external URL');
    },
  },
};
</script>

<style lang="scss" scoped>
  .learn-more {
    text-align: right;
  }
</style>
